/**
 * @generated SignedSource<<2c4e4a87b3116bc87dc200e28f238ca3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionApprovalsFragment$data = {
  readonly hasSubmissions: boolean;
  readonly viewerCanApprove: boolean;
  readonly viewerCanReadPrivateApproval: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionScoringCriteriaFragment" | "FiltersForCompetitionApprovalsFragment" | "SubmissionsCompetitionApprovalsFragment">;
  readonly " $fragmentType": "CompetitionApprovalsFragment";
};
export type CompetitionApprovalsFragment$key = {
  readonly " $data"?: CompetitionApprovalsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionApprovalsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "stage",
  "variableName": "stage"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "approvalFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "stage"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompetitionApprovalsFragment",
  "selections": [
    {
      "alias": "viewerCanApprove",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_PROJECT_VERSION_APPROVAL"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_PROJECT_VERSION_APPROVAL\")"
    },
    {
      "alias": "viewerCanReadPrivateApproval",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "READ_COMPETITION_PRIVATE_APPROVAL"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"READ_COMPETITION_PRIVATE_APPROVAL\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasSubmissions",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FiltersForCompetitionApprovalsFragment"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "approvalFilter",
          "variableName": "approvalFilter"
        },
        (v0/*:: as any*/)
      ],
      "kind": "FragmentSpread",
      "name": "SubmissionsCompetitionApprovalsFragment"
    },
    {
      "args": [
        (v0/*:: as any*/)
      ],
      "kind": "FragmentSpread",
      "name": "CompetitionScoringCriteriaFragment"
    }
  ],
  "type": "Competition",
  "abstractKey": null
};
})();

(node as any).hash = "6c97a519259953cf7e257ff9305ebce2";

export default node;
